import React from 'react';
import Navbar from '../components/Navbar';
import LegalSection from '../components/LegalSection';
import Footer from '../components/Footer';
import { Link } from 'react-router-dom';
import logo from '../img/logo.png';

const Privacy = () => {
  return (
    <>
      <nav className="stroke navbar navbar-expand-md navbar-light bg-light fixed-top shadow-sm">
        <div className="container">
          <Link className="navbar-brand" to="/">
            <img src={logo} alt="Kanzlei Logo" className="navbar-logo" />
          </Link>
          <button
            className="navbar-toggler"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarNav"
          >
            <span className="navbar-toggler-icon"></span>
          </button>
          <div className="collapse navbar-collapse" id="navbarNav">
            <ul className="navbar-nav ms-auto">
              <li className="nav-item">
                <Link className="nav-link" to="/">Home</Link>
              </li>
              <li className="nav-item">
                <Link className="nav-link" to="/#taetigkeiten">Tätigkeiten</Link>
              </li>
              <li className="nav-item">
                <Link className="nav-link" to="/#ueber-mich">Über mich</Link>
              </li>
              <li className="nav-item">
                <Link className="nav-link" to="/#arbeitsweise">Arbeitsweise & Vorteile</Link>
              </li>
              <li className="nav-item">
                <Link className="nav-link" to="/#kontakt">Kontakt</Link>
              </li>
            </ul>
          </div>
        </div>
      </nav>

      <LegalSection>
        <div className="mb-2">
          <h1 className="display-5 fw-bold mb-1">Datenschutzerklärung</h1>
        </div>

        <p><strong>Stand:</strong> 19. Juni 2025</p>

        <h2>1. Allgemeine Hinweise</h2>
        <p>
          Diese Datenschutzerklärung informiert Sie gemäß <strong>Art. 13 und 14 Datenschutz-Grundverordnung (DSGVO)</strong>, dem <strong>Bundesdatenschutzgesetz (BDSG)</strong> sowie dem <strong>Telekommunikation-Telemedien-Datenschutz-Gesetz (TTDSG)</strong> über die Verarbeitung personenbezogener Daten beim Besuch dieser Website.
        </p>
        <p><strong>Verantwortlicher:</strong><br />
          <strong>Rechtsanwalt Sergej Vorrat</strong><br />
          Kobergerplatz 13<br />
          90408 Nürnberg<br />
          Telefon: <strong>01577 3430153</strong><br />
          E-Mail: <strong>kanzlei@ravorrat.de</strong><br />
          Webseite: <a href="https://ra-vorrat.de">https://ra-vorrat.de</a>
        </p>

        <h2>2. Rechte der betroffenen Personen</h2>
        <ul>
          <li><strong>Auskunft</strong> über Ihre gespeicherten Daten (Art. 15 DSGVO),</li>
          <li><strong>Berichtigung</strong> unrichtiger Daten (Art. 16 DSGVO),</li>
          <li><strong>Löschung</strong> (Art. 17 DSGVO),</li>
          <li><strong>Einschränkung</strong> der Verarbeitung (Art. 18 DSGVO),</li>
          <li><strong>Datenübertragbarkeit</strong> (Art. 20 DSGVO),</li>
          <li><strong>Widerspruch</strong> gegen die Verarbeitung (Art. 21 DSGVO),</li>
          <li><strong>Widerruf</strong> einer erteilten Einwilligung mit Wirkung für die Zukunft (Art. 7 Abs. 3 DSGVO).</li>
        </ul>
        <p>
          Sie haben zudem das Recht auf <strong>Beschwerde</strong> bei einer Aufsichtsbehörde (Art. 77 DSGVO).
        </p>
        <p><strong>Zuständig ist:</strong><br />
          <strong>Bayerisches Landesamt für Datenschutzaufsicht (BayLDA)</strong><br />
          Promenade 18, 91522 Ansbach<br />
          <a href="https://www.lda.bayern.de">https://www.lda.bayern.de</a>
        </p>

        <h2>3. Hosting</h2>
        <p>
          Diese Website wird gehostet bei:<br />
          <strong>Hostinger International Ltd.</strong><br />
          61 Lordou Vironos Street<br />
          6023 Larnaca, Zypern
        </p>
        <p>Beim Besuch der Website werden durch den Hostinganbieter automatisch folgende Daten in sogenannten Server-Logfiles erhoben und gespeichert:</p>
        <ul>
          <li>IP-Adresse des anfragenden Endgeräts</li>
          <li>Datum und Uhrzeit des Zugriffs</li>
          <li>Name und URL der abgerufenen Datei</li>
          <li>Website, von der aus der Zugriff erfolgt (Referrer-URL)</li>
          <li>Browsertyp und -version sowie verwendetes Betriebssystem</li>
          <li>Zugriffsstatus (HTTP-Statuscode)</li>
        </ul>
        <p>
          Diese Daten sind technisch erforderlich, um die Website korrekt anzuzeigen sowie Stabilität und Sicherheit zu gewährleisten.
        </p>
        <p>
          <strong>Rechtsgrundlage:</strong> Art. 6 Abs. 1 lit. f DSGVO (berechtigtes Interesse an Stabilität und Sicherheit)<br />
          Die Server-Logdaten werden in der Regel für maximal 7 Tage gespeichert und anschließend gelöscht oder anonymisiert.<br />
          Ein Auftragsverarbeitungsvertrag gemäß Art. 28 DSGVO wurde mit Hostinger geschlossen.
        </p>

        <h2>4. SSL-/TLS-Verschlüsselung</h2>
        <p>
          Diese Website nutzt aus Sicherheitsgründen eine <strong>SSL- bzw. TLS-Verschlüsselung</strong>. Eine verschlüsselte Verbindung erkennen Sie an der Adresszeile des Browsers („https://“) und dem Schloss-Symbol.
        </p>

        <h2>5. Eingesetzte externe Ressourcen</h2>
        <p>
          <strong>5.1 Google Fonts lokal eingebunden:</strong><br />
          Google Fonts sind lokal auf unserem Server eingebunden. Es erfolgt keine Verbindung zu Google-Servern. Es werden daher keine personenbezogenen Daten an Dritte übermittelt.
        </p>
        <p>
          <strong>5.2 Bootstrap (via CDN):</strong><br />
          Für das Layout verwenden wir Bootstrap über ein Content Delivery Network (CDN). Hierbei kann es technisch erforderlich sein, dass Ihre IP-Adresse beim Abruf einzelner Dateien an Dritte (z. B. jsDelivr oder BootstrapCDN) übertragen wird. <br />
          <strong>Rechtsgrundlage:</strong> Art. 6 Abs. 1 lit. f DSGVO (berechtigtes Interesse an einem technisch ansprechenden Webauftritt)<br />
          <strong>Hinweis:</strong> Bei Nutzung externer CDNs kann eine Datenübertragung in Drittländer nicht ausgeschlossen werden.
        </p>
        <p>
          <strong>5.3 Web3Forms:</strong><br />
          Zur Übermittlung von Nachrichten über unser Kontaktformular nutzen wir den Dienst Web3Forms.<br />
          <strong>Anbieter:</strong><br />
          Web3Forms, betrieben durch OceanSoftech<br />
          Weitere Informationen: <a href="https://web3forms.com/privacy">https://web3forms.com/privacy</a>
        </p>
        <p><strong>Verarbeitete Daten:</strong></p>
        <ul>
          <li>Name</li>
          <li>E-Mail-Adresse</li>
          <li>Nachricht</li>
          <li>IP-Adresse</li>
          <li>Zeitpunkt der Anfrage</li>
        </ul>
        <p>
          Diese Daten werden über Web3Forms an uns übermittelt. Web3Forms verwendet zur Datenverarbeitung Google Workspace (Google LLC, USA). Die Übermittlung in Drittländer erfolgt auf Grundlage von <strong>Standardvertragsklauseln gemäß Art. 46 DSGVO</strong>, um ein angemessenes Datenschutzniveau zu gewährleisten.
        </p>
        <p><strong>Rechtsgrundlage:</strong></p>
        <ul>
          <li>Art. 6 Abs. 1 lit. b DSGVO (Anbahnung oder Durchführung eines Vertrags)</li>
          <li>Art. 6 Abs. 1 lit. f DSGVO (berechtigtes Interesse an sicherer und effizienter Kontaktaufnahme)</li>
        </ul>
        <p>Ein Auftragsverarbeitungsvertrag mit Web3Forms wurde geschlossen.</p>

        <h2>6. Kontaktaufnahme</h2>
        <p>
          Wenn Sie uns per E-Mail oder über das Kontaktformular kontaktieren, verarbeiten wir Ihre Angaben ausschließlich zur Bearbeitung Ihrer Anfrage.
        </p>
        <p><strong>Rechtsgrundlage:</strong></p>
        <ul>
          <li>Art. 6 Abs. 1 lit. b DSGVO (vorvertragliche Maßnahmen)</li>
          <li>Art. 6 Abs. 1 lit. f DSGVO (berechtigtes Interesse an der Kommunikation)</li>
        </ul>
        <p>
          <strong>Speicherdauer:</strong><br />
          Die Daten werden nach abschließender Bearbeitung der Anfrage gelöscht, sofern keine gesetzlichen Aufbewahrungspflichten bestehen (z. B. nach dem Handelsgesetzbuch oder der Abgabenordnung).
        </p>

        <h2>7. Cookies und Tracking</h2>
        <p>
          Diese Website verwendet ausschließlich <strong>technisch notwendige Cookies</strong>, die für den Betrieb der Website unerlässlich sind. Es findet <strong>kein Tracking</strong>, <strong>keine Webanalyse</strong> und <strong>keine Speicherung von personenbezogenen Daten zu Werbezwecken</strong> statt.<br />
          Daher ist kein Cookie-Banner erforderlich.
        </p>

        <h2>8. Speicherdauer</h2>
        <p>
          Personenbezogene Daten werden nur solange gespeichert, wie dies zur Erreichung der jeweiligen Verarbeitungszwecke erforderlich ist oder gesetzliche Aufbewahrungspflichten bestehen. Nach Wegfall des Verarbeitungszwecks oder Ablauf gesetzlicher Fristen werden die Daten gelöscht oder anonymisiert.
        </p>

        <h2>9. Änderungen dieser Datenschutzerklärung</h2>
        <p>
          Wir behalten uns vor, diese Datenschutzerklärung bei Änderungen technischer, rechtlicher oder organisatorischer Art anzupassen. Die jeweils aktuelle Fassung finden Sie jederzeit auf dieser Website.
        </p>

        <h2>Hinweis:</h2>
        <p>
          Diese Datenschutzerklärung wurde nach bestem Wissen und auf Grundlage der geltenden Datenschutzvorschriften erstellt. Im Zweifel gilt der Wortlaut der DSGVO.
        </p>
      </LegalSection>

      <Footer />
    </>
  );
};

export default Privacy;
